import React from "react";
import { Link } from "react-router-dom";
import "./styles/Navbar.css";
import { FaSearch, FaBars, FaQuestionCircle } from "react-icons/fa";
import logo_g from "../assets/logo_godiway_celeste_blanco_209_44.png";
import logo_p from "../assets/logo_godiway_celeste_blanco_51_44.png";
import * as actions from "../redux/actions/adSearchActions";
import * as actions_store from "../redux/actions/marketStoreSearchActions";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import MenuMobileOut from "./MenuMobileOut";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

class NavbarOut extends React.Component {
  state = {
    search_text: "",
    mobile: false,
    marketstore: false,
  };

  onSearch = async (event) => {
    event.preventDefault();
    if (this.state.marketstore) {
      return;
    }
    try {
      if (this.props.history.location.pathname !== "/goder/search") {
        this.props.history.push("/goder/search");
      }

      await this.props
        .AdSearch(this.state.search_text)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onChange = (event) => {
    const searchText = event.target.value;
    const marketstore = searchText.startsWith("@");

    this.setState({ search_text: searchText, marketstore });

    if (marketstore && searchText.length > 1) {
      this.fecthSearchMarketStore(searchText);
    }
  };

  async fecthSearchMarketStore(searchText) {
    try {
      await this.props
        .MarketstoreSearch({
          text: searchText || this.state.search_text,
          lang: I18n.t("locale"),
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  onClickMenuMobile = () => {
    this.setState({ mobile: !this.state.mobile });
  };

  onClickGoMarketStore = (item, evt) => {
    evt.preventDefault();
    this.setState({ search_text: "", marketstore: false });
    this.props.history.push(`/marketstore/show/${item.Id}`);
  };

  render() {
    let suggestionsListComponent;

    if (this.state.search_text && this.state.marketstore) {
      if (this.props.marketStoreCount) {
        suggestionsListComponent = (
          <ul className="card suggestions">
            {this.props.marketStoreList.map((item) => (
              <li
                key={item.Id}
                onClick={(evt) => {
                  this.onClickGoMarketStore(item, evt);
                }}
              >
                <img
                  src={item.Logo}
                  className="rounded-circle"
                  style={{ height: "30px", width: "30px" }}
                  alt="GW"
                />
                &nbsp;
                {item.Name}
              </li>
            ))}
          </ul>
        );
      } else {
        suggestionsListComponent = (
          <div className="card no-suggestions">
            <em>No suggestions...!</em>
          </div>
        );
      }
    }

    return (
      <nav className="navbar" role="navigation">
        <div className="navbar-brand-big">
          <Link to="/">
            <img src={logo_g} alt="Godiway" />
          </Link>
        </div>
        <div className="navbar-brand-small">
          <Link to="/">
            <img src={logo_p} alt="Godiway" />
          </Link>
        </div>

        <div className="navbar-center">
          <div className="navbar-form">
            <form onSubmit={this.onSearch}>
              <div className="form-group">
                <div className="input-group navbar-search-group">
                  <input
                    type="text"
                    className="form-control"
                    name="searcher"
                    placeholder={I18n.t("search_what")}
                    maxLength="80"
                    value={this.state.search_text}
                    onChange={this.onChange}
                    autoComplete="off"
                  />
                  <div className="input-group-append">
                    <button
                      type="submit"
                      className="btn navbar-search-btn"
                      onClick={this.onSearch}
                      aria-label={I18n.t("search_what")}
                    >
                      <FaSearch />
                    </button>
                  </div>
                </div>
                {suggestionsListComponent}
              </div>
            </form>
          </div>
        </div>

        <div className="navbar-mobile">
          <button
            type="button"
            className="navbar-mobile-toggle"
            onClick={this.onClickMenuMobile}
            aria-label="Menu"
          >
            <FaBars />
          </button>
          {this.state.mobile && (
            <MenuMobileOut onClick={this.onClickMenuMobile} />
          )}
        </div>

        <div className="navbar__actions">
          <div className="navbar-items">
            <div className="nav-item">
              <Link
                to="/faq_me"
                className="navbar-icon-link"
                title="FAQ"
              >
                <FaQuestionCircle />
              </Link>
            </div>
            <div className="nav-item">
              <Link className="navbar-text-link" to="/login">
                <Translate value="login" />
              </Link>
            </div>
            <div className="nav-item">
              <Link
                to="/register"
                className="btn navbar-cta"
                title="Registrate en Godiway"
              >
                <Translate value="godiway_join" />
              </Link>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    lang: reducer.i18n.locale,
    marketStoreList: reducer.marketstoreSearch.list,
    marketStoreCount: reducer.marketstoreSearch.page_count,
    error: reducer.marketstoreSearch.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  AdSearch: (text) => dispatch(actions.loadListOut({ text })),
  MarketstoreSearch: (params) =>
    dispatch(actions_store.marketstoreSearch({ params })),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NavbarOut)
);
